const TYPE = "Cascade";

export const GET_RESULT_LIST = `${TYPE}/get_result_list`;